import SodRemediateSubmitComment from './SodRemediateSubmitComment';

export default SodRemediateSubmitComment;
